import React from 'react';
import PropTypes from 'prop-types';
import { imageSet } from '../../../helper/Images';

const Summary = ({ img, name, desc }) => (
  <div className="result-description">
    <div className="result-description--left">
      <img
        className="img-responsive result-item--img"
        src={imageSet[img]}
        alt=""
      />
    </div>
    <div className="result-description--right">
      <div className="result-item--name">{name}</div>
      <div className="result-item--desc">{desc}</div>
    </div>
  </div>
);
Summary.propTypes = {
  img: PropTypes.string,
  name: PropTypes.string,
  desc: PropTypes.string,
};
export default Summary;
